export default __webpack_public_path__ + "static/media/Documents.30cb70bd.svg";